import {
  BLOCK_BOOKING_ALIAS,
  FREE_TRIAL_PROCESS_ALIAS,
} from '../../session-details/config/listings';
import { FREE_BOOKING_PROCESS_ALIAS } from '../../free-booking/transactions/transactionProcessFreeBooking';
import { FREE_BLOCK_BOOKING_PROCESS_ALIAS } from '../../free-booking/transactions/transactionProcessFreeBlockBooking';
import { FREE_DEFAULT_BOOKING_PROCESS_ALIAS } from '../../free-booking/transactions/transactionProcessFreeDefaultBooking';

/**
 * Resolves the transaction process alias to initiate/transition under, based on
 * the selected ticket option and listing pricing.
 *
 * A block booking reaches the free-block-booking process (no Stripe step) two ways: a
 * valid free promo code, or a listing the provider marked free. Otherwise block bookings
 * use the standard block-booking process. Free trials and free single events have their
 * own processes. Everything else falls back to the listing's configured process alias.
 *
 * Shared by CheckoutPage.duck, CheckoutPageTransactionHelpers, ListingPage.duck and
 * applyPromoCode.duck so the routing lives in one place. Callers that don't deal with
 * free listings simply omit the free flags.
 *
 * @param {Object}  args
 * @param {String}  [args.ticketOption]
 * @param {String}  [args.processAlias]       fallback alias (e.g. from listing publicData)
 * @param {Boolean} [args.isFreeClass]        free single event
 * @param {Boolean} [args.isFreeBlockBooking] free block booking listing (CH-508)
 * @param {Boolean} [args.isFreePromoCode]
 * @returns {String} process alias
 */
export const determineTxProcessAlias = ({
  ticketOption,
  processAlias,
  isFreeClass,
  isFreeBlockBooking,
  isFreePromoCode,
}) => {
  if (ticketOption === 'payAsYouGo' && isFreePromoCode) {
    return FREE_DEFAULT_BOOKING_PROCESS_ALIAS;
  }
  if (ticketOption?.includes('blockBooking') && (isFreePromoCode || isFreeBlockBooking)) {
    return FREE_BLOCK_BOOKING_PROCESS_ALIAS;
  }
  if (ticketOption?.includes('blockBooking')) {
    return BLOCK_BOOKING_ALIAS;
  }
  if (ticketOption === 'freeTrial') {
    return FREE_TRIAL_PROCESS_ALIAS;
  }
  if (isFreeClass) {
    return FREE_BOOKING_PROCESS_ALIAS;
  }
  return processAlias;
};
